import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EmployeeDropdownResult, Priority, Result, SubTaskInput, SubTaskResult, TicketTaskResult } from 'app/models';
import { SubTaskService } from 'app/services';
import { Utility } from 'app/shared';

@Component({
  selector: 'app-sub-task-detail',
  templateUrl: './sub-task-detail.component.html',
  styleUrls: ['./sub-task-detail.component.scss']
})
export class SubTaskDetailComponent implements OnInit {
  private idForDelete?: number | null;

  public utility = Utility;
  public priority = Priority;

  @Input()
  public ticketTaskResult: TicketTaskResult = new TicketTaskResult();

  @Input()
  public employeeDropdown = new Array<EmployeeDropdownResult>();

  public isBusy: boolean = false;
  public subtasks: SubTaskResult[] = [];
  public subtask: SubTaskResult = new SubTaskResult();
  public result: Result = new Result();

  constructor(
    private modalService: NgbModal,
    private subTaskService: SubTaskService) {
  }

  ngOnInit(): void {
    this.showSubTasks();
  }

  public showSubTasks(): void {
    if (this.isBusy === false) {
      this.isBusy = true;
      this.subTaskService.getSubTasks(this.ticketTaskResult.id).then(result => {
        if (result.success === true) {
          this.subtasks = result.data;
          this.subtasks.forEach(item => {
            item.oldTitle = '';
            item.isEditMode = false;
          });
        } else {
          this.result = result;
        }
      }).finally(() => {
        this.isBusy = false;
      });
    }
  }

  public createSubTask(): void {
    const subTaskResult = new SubTaskResult();
    subTaskResult.id = 0;
    subTaskResult.isDeleted = false;
    subTaskResult.isDone = false;
    subTaskResult.ticketId = this.ticketTaskResult.id;
    subTaskResult.title = '';
    this.subtasks.push(subTaskResult);
  }

  public addSubTask(temp: SubTaskResult): void {
    if (temp.title.trim() !== '') {
      if (this.isBusy === false) {
        this.isBusy = true;
        const subTaskInput = new SubTaskInput();
        subTaskInput.ticketId = this.ticketTaskResult.id;
        subTaskInput.title = temp.title;
        this.subTaskService.addSubTask(subTaskInput).then(result => {
          this.isBusy = false;
          if (result.success === true) {
            this.showSubTasks();
          } else {
            this.result = result;
          }
        }).catch(() => {
          this.isBusy = false;
        });
      }
    }
  }

  public changeToEditMode(temp: SubTaskResult): void {
    temp.oldTitle = temp.title;
    temp.isEditMode = true;
  }

  public cancelSubTask(temp: SubTaskResult): void {
    if (temp.id === 0) {
      this.subtasks = this.subtasks.filter(r => r !== temp);
    } else {
      temp.title = temp.oldTitle;
      temp.isEditMode = false;
    }
  }

  public editSubTask(temp: SubTaskResult): void {
    if (temp.title.trim() !== '') {
      if (this.isBusy === false) {
        this.isBusy = true;
        const subTaskInput = new SubTaskInput();
        subTaskInput.ticketId = this.ticketTaskResult.id;
        subTaskInput.title = temp.title;
        this.subTaskService.editSubTask(temp.id, subTaskInput).then(result => {
          this.isBusy = false;
          if (result.success === true) {
            this.showSubTasks();
          } else {
            this.result = result;
          }
        }).catch(() => {
          this.isBusy = false;
        });
      }
    }
  }

  public deleteSubTask(): void {
    if (this.isBusy === false) {
      this.isBusy = true;
      this.subTaskService.deleteSubTask(this.idForDelete ?? 0).then(result => {
        if (result.success === true) {
          this.modalService.dismissAll();
          this.isBusy = false;
          this.showSubTasks();
        } else {
          this.result = result;
        }
      }).catch(() => {
        this.isBusy = false;
      });
    }
  }

  public changeIsDone(item: SubTaskResult): void {
    if (this.isBusy === false) {
      this.isBusy = true;
      this.subTaskService.editSubTaskStatus(item.id, item.isDone).then(result => {
        if (result.success === true) {
          this.isBusy = false;
          this.showSubTasks();
        } else {
          this.result = result;
        }
      }).catch(() => {
        this.isBusy = false;
      });
    }
  }

  public assignedSubtask(subtaskId: number, employeeId: number): void {
    if (this.isBusy === false) {
      this.subtask = new SubTaskResult();
      this.modalService.dismissAll();
      this.isBusy = true;
      this.subTaskService.updateSubtaskAssignee(subtaskId, employeeId).then(result => {
        this.isBusy = false;
        if (result.success === true) {
          this.showSubTasks();
        } else {
          this.result = result;
        }
      }).catch(() => {
        this.isBusy = false;
      });
    }
  }

  public openAlertModal(modalDanger: any, id: number): void {
    this.idForDelete = id;
    this.modalService.open(modalDanger, {
      centered: true,
      windowClass: 'modal modal-danger'
    });
  }

  public openSubtaskAssignModal(subtaskAssignModal: any, subtask: SubTaskResult): void {
    this.subtask = subtask;
    this.modalService.open(subtaskAssignModal, {
      centered: true,
      windowClass: 'modal modal-info'
    });
  }
}
